import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useMagnetic } from './motion';

/** Link/botão com atração magnética. `to` usa o router; `href` vira <a>. */
function MagneticLink({ to, href, onClick, variant = 'primary', className = '', children, ...rest }) {
  const ref = useRef(null);
  useMagnetic(ref);
  const cls = `hv3-btn hv3-btn--${variant} ${className}`;
  const inner = (
    <span className="hv3-btn-inner" data-magnetic-inner>
      {children}
    </span>
  );
  if (to) {
    return (
      <Link ref={ref} to={to} className={cls} onClick={onClick} {...rest}>
        {inner}
      </Link>
    );
  }
  return (
    <a ref={ref} href={href} className={cls} onClick={onClick} {...rest}>
      {inner}
    </a>
  );
}

export default MagneticLink;
